import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Cms from './views/Cms.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/',

    routes: [{
        path: '/',
        name: 'home',
        component: Home
    // }, {
    //     path: '/cms',
    //     name: 'cms',
    //     component: Cms
    }]
})
